var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotel = function SvgHotel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M40-200v-600h80v400h320v-320h320q66 0 113 47t47 113v360h-80v-120H120v120zm240-240q-50 0-85-35t-35-85 35-85 85-35 85 35 35 85-35 85-85 35m240 40h320v-160q0-33-23.5-56.5T760-640H520zM280-520q17 0 28.5-11.5T320-560t-11.5-28.5T280-600t-28.5 11.5T240-560t11.5 28.5T280-520m240-120v240z"
  })));
};
export default SvgHotel;